import * as util from 'util';
import BestaFrameLegsSystemComponent from './BestaFrameLegsSystemComponent';
/**
 * This component will be procedurally added to a BESTÅ frame that should have legs.
 * It contains all data needed to build the assembly's legs properly. So if any data changes on this
 * component, legs need to be rebuilt. By keeping all data in one component, any change to it will trigger
 * a rebuild, and all the data needded for this operation is contained in this one component.
 */
export class BestaLegsComponent {
    get mergedLegsLeft() {
        return this._leftNeighbour !== null;
    }
    get mergedLegsRight() {
        return this._rightNeighbour !== null;
    }
    get hasLegs() {
        return this._hasLegs;
    }
    get leftNeighbour() {
        return this._leftNeighbour;
    }
    get rightNeighbour() {
        return this._rightNeighbour;
    }
    get legProductRef() {
        return this._legProductRef;
    }
    get useSupportLeg() {
        return this._useSupportLeg;
    }
    constructor(isOnFloor, leftNeighbour, rightNeighbour, legProductRef, useSupportLeg) {
        this.typeId = BestaFrameLegsSystemComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
        // Note that this is the data that is needed to determine which legs to put on and which to merge.
        // If any of this changes, then the assembly must be rebuilt
        this._hasLegs = isOnFloor;
        this._leftNeighbour = leftNeighbour;
        this._rightNeighbour = rightNeighbour;
        this._legProductRef = legProductRef;
        this._useSupportLeg = useSupportLeg;
    }
    eq(other) {
        return (this._hasLegs === other._hasLegs &&
            this.leftNeighbour === other.leftNeighbour &&
            this.rightNeighbour === other.rightNeighbour &&
            this._legProductRef === other._legProductRef &&
            this._useSupportLeg === other._useSupportLeg);
    }
    toJson(parse) {
        return parse(util.inspect(this));
    }
    serializationKey() {
        return 'BestaLegsComponent';
    }
    withLeftNeighbour(leftNeighbour) {
        return new BestaLegsComponent(this._hasLegs, leftNeighbour, this._rightNeighbour, this._legProductRef, this._useSupportLeg);
    }
    withRightNeighbour(rightNeighbour) {
        return new BestaLegsComponent(this._hasLegs, this._leftNeighbour, rightNeighbour, this._legProductRef, this._useSupportLeg);
    }
    withLegProductRef(legProductRef, useSupportLeg) {
        return new BestaLegsComponent(this._hasLegs, this._leftNeighbour, this._rightNeighbour, legProductRef, useSupportLeg);
    }
    withConnectedToFloor(connectedToFloor) {
        return new BestaLegsComponent(connectedToFloor, this._leftNeighbour, this._rightNeighbour, this._legProductRef, this._useSupportLeg);
    }
    withConnectedToNothing() {
        return new BestaLegsComponent(false, null, null, this._legProductRef, this._useSupportLeg);
    }
}
BestaLegsComponent.id = BestaFrameLegsSystemComponent.id;
//# sourceMappingURL=BestaLegsComponent.js.map